var $4bd033b8564f5b3a$exports = {};
$4bd033b8564f5b3a$exports = {
    "valid": `Valid`
};


export {$4bd033b8564f5b3a$exports as default};
//# sourceMappingURL=en-US.mjs.map
